// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.error-info-container p[data-v-6dcbab9c] {\n  margin: 0 0 10px;\n}\n.error-info-container h1[data-v-6dcbab9c] {\n  font-weight: normal;\n  font-size: 26px;\n  color: #4d148c;\n  padding: 0;\n  margin: 20px 0 20px 0;\n  line-height: 45px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
